import { useRoutes, useLocation, useNavigate } from "react-router-dom";
import { RouterMap, Routers } from "~@/config/routes";
import zhCN from "antd/locale/zh_CN";
import { ConfigProvider } from "antd";
import { theme } from "~@/config/theme";
import Layout from "~@/components/Layout";
import React, { useEffect, useMemo } from "react";
import { useUser } from "~@/hooks/useUser";

function App() {
  const { user, setUser } = useUser((state) => state);
  const navigate = useNavigate();
  const element = useRoutes(Routers);
  const location = useLocation();

  const route = useMemo(() => {
    const route = Routers?.find((route) => route.path === location.pathname);
    return route;
  }, [location]);

  const LayoutComponent = route?.layout === undefined ? Layout : React.Fragment;

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (!user && searchParams.get("user")) {
      setUser({ user: searchParams.get("user") as string });
      // navigate(RouterMap.ORDER_LIST.path, { replace: true });
    } else if (!user && location.pathname !== RouterMap.LOGIN.path) {
      // navigate(RouterMap.LOGIN.path, { replace: true });
    } else if (user && location.pathname === RouterMap.LOGIN.path) {
      // navigate(RouterMap.ORDER_LIST.path, { replace: true });
    }
  }, [user, navigate, location, setUser]);
  return (
    <ConfigProvider theme={theme} locale={zhCN}>
      <LayoutComponent>{element}</LayoutComponent>
    </ConfigProvider>
  );
}

export default App;
